var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 36,
    viewBox: "0 0 87 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24537e-07 30.0001C2.34843e-07 33.3138 2.68629 36.0001 6 36.0001L81 36.0001C84.3137 36.0001 87 33.3138 87 30.0001L87 10.0001C87 6.68635 84.3137 4.00006 81 4.00005L33.1097 4.00003C31.4794 4.00003 29.9193 3.33661 28.7883 2.1624C27.7191 1.05234 26.4057 6.33672e-05 24.8645 6.32325e-05L6 6.15833e-05C2.6863 6.12936e-05 2.91238e-06 2.68636 2.62268e-06 6.00006L5.24537e-07 30.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.4adaedaa0cdd5cd81f5e933ed686f916.svg";
export { ForwardRef as ReactComponent };